<template>
	<v-row class="ma-2">
		<v-flex lg6 xs12 sm12 class="pt-0">
			<v-row no-gutters>
				<v-col cols="6">
					<div :class="['text-h6', 'pa-0', 'pl-2']">{{ $t('titles.recommendations') }}</div>
				</v-col>
				<v-col cols="6">
					<div :class="['text-h6', 'pa-0', 'pl-1']">{{ $t('titles.concessions') }}</div>
				</v-col>
			</v-row>
			<v-row class="pt-4">
				<v-col cols="6" class="pt-0">
					<v-row dense class="pl-3">
						<v-col cols="12">
							<NumberField
								:readonly="true"
								v-model="course.price"
								:precision="2"
								:label="$t('fields.price')"
							></NumberField>
						</v-col>
						<v-col cols="12">
							<NumberField
								:readonly="true"
								v-model="course.students_limit"
								:label="$t('fields.studentsLimit')"
							></NumberField>
						</v-col>
						<v-col cols="12">
							<NumberField
								:readonly="true"
								v-model="course.duration_hours"
								:label="$t('fields.durationHours')"
							></NumberField>
						</v-col>
						<v-col cols="12">
							<NumberField
								:readonly="true"
								v-model="course.duration_days"
								:label="$t('fields.durationDays')"
							></NumberField>
						</v-col>
					</v-row>
				</v-col>
				<v-col cols="6" class="pt-0 pl-1">
					<v-col cols="12" class="pl-0 pt-0">
						<v-card flat>
							<v-card-text class="pa-0">
								<v-container v-if="course.offices.length > 0" class="pa-0">
									<v-row v-for="(item, key) in course.offices" :key="key" no-gutters>
										<v-col cols="12" class="pb-1 pt-0">
											<v-card
												:key="item.id"
												outlined
												:class="{ 'module-item': $vuetify.theme.dark }"
											>
												<v-row no-gutters>
													<v-col cols="6" class="pt-1 pl-2 d-flex align-center">
														<div :class="['text-subtitle-1', 'pa-2', 'pl-0']">
															{{ item.officeName }}
														</div>
													</v-col>
													<v-col cols="6" class="pt-1 pl-2 d-flex align-center">
														<div :class="['text-subtitle-1', 'pa-2', 'pl-1']">
															{{ item.dateDisplay }}
														</div>
													</v-col>
												</v-row>
											</v-card>
										</v-col>
									</v-row>
								</v-container>
							</v-card-text>
						</v-card>
					</v-col>
				</v-col>
			</v-row>
		</v-flex>
		<v-flex lg6 xs12 sm12 v-if="initialLoad == true">
			<div :class="['text-h6']" v-if="course.modules.length > 0">{{ $t('titles.modules') }}</div>
			<v-container class="overflow-container mt-4 pt-0 pb-0">
				<v-row v-for="(item, key) in course.modules" :key="key" class="pr-8">
					<v-col cols="12" class="pa-0 pb-1">
						<v-card :key="item.id" outlined>
							<div :class="['text-h8', 'pa-2']">{{ item.name }}</div>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</v-flex>
	</v-row>
</template>

<script>
import Course from '../../../models/Course';
import NumberField from '../../trinkets/NumberField';

export default {
	name: 'Recommendations',
	components: { NumberField },
	props: {
		courseId: [String, Number],
	},
	data: function () {
		return {
			course: new Course({}),
			inEditMode: false,
			initialLoad: false,
		};
	},
	watch: {
		courseId: 'loadData',
	},
	methods: {
		loadData() {
			if (this.courseId) {
				let vm = this;
				this.$APICall('get', 'courses/' + this.courseId, {}, (data, success) => {
					if (success) {
						let usableData = JSON.parse(JSON.stringify(data));
						vm.course = usableData;
						vm.$emit('duration', vm.course.duration_days);
						vm.initialLoad = true;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			}
		},
	},

	mounted() {
		this.loadData();
	},
};
</script>

<style scoped>
.overflow-container {
	max-height: 265px;
	overflow-y: auto;
}
</style>
